// extracted by mini-css-extract-plugin
export var background = "_5l-0";
export var container = "_5l-1";
export var contentItem = "_5l-7";
export var extendedWarranty = "_5l-5";
export var link = "_5l-d";
export var modal = "_5l-b";
export var modalCloseButton = "_5l-9";
export var modalContent = "_5l-3";
export var modalContentMain = "_5l-6";
export var modalImageLogo = "_5l-8";
export var modalLogo = "_5l-a";
export var modalSideImage = "_5l-4";
export var preview = "_5l-c";
export var redoModal = "_5l-2";